export const copyToClipboard = (textToCopy: string) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy);
        return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}
